import { UserDetailContext } from "#src/routes/settings/users/detail/UserDetailContext";
import {
  KeyValuePanel,
  TelephoneDisplay,
  TextDataDisplay,
} from "@validereinc/common-components";
import { UserTypeEnum } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import formatInTimeZone from "date-fns-tz/formatInTimeZone";
import React, { useContext } from "react";

export const UserDetailsPanel = () => {
  const { userDetails } = useContext(UserDetailContext) ?? {};

  return (
    <KeyValuePanel
      panelMaxColumnCount={2}
      panelKeyValueListProps={{ maxRowCount: 3, variant: "shaded" }}
      panelProps={{ isFluidY: false }}
      data={[
        {
          title: "Name",
          value: userDetails?.data?.name,
        },
        {
          title: "Type",
          value: (
            <TextDataDisplay
              value={
                userDetails?.data?.type
                  ? toTitleCaseString(userDetails.data.type, { intent: "ui" })
                  : "—"
              }
              alignment="right"
            />
          ),
        },
        ...(userDetails?.data?.type === UserTypeEnum.human
          ? [
              {
                title: "Phone  Number",
                value: (
                  <TelephoneDisplay
                    value={userDetails?.data?.phone}
                    fallbackDisplay={<span>-</span>}
                  />
                ),
              },
              {
                title: "Email",
                value: userDetails?.data?.email ?? "-",
              },
            ]
          : []),
        {
          title: "Timezone",
          value:
            userDetails?.data?.timezone &&
            `${userDetails.data.timezone} (${formatInTimeZone(
              new Date(),
              userDetails.data.timezone,
              "E p, O"
            )})`,
        },
      ]}
    />
  );
};
